import React from 'react'
const NotFound = () => {
  return (
    <div>We all wonder where we don't belong</div>
  )
}

export default NotFound